import { ProfileService } from './containers/profile/profile.service'
import { DiscountGroupsService } from './containers/discount-groups/discount-groups.service'
import { SearchResultsService } from './containers/search-results/search-results.service'
import { DashboardService } from './containers/dashboard/dashboard.service'
import { MapService } from './containers/map/map.service'
import { ReportsService } from './containers/reports/reports.service'
import { FixedTemplatesService } from './containers/fixed-templates/fixed-templates.service'
import { RolesService } from './containers/roles/roles.service'
import { BusinessesService } from './containers/businesses/businesses.service'
import { DocumentTypesService } from './containers/document-types/document-types.service'
import { PdfBatchGenerationService } from './containers/pdf-batch-generation/pdf-batch-generation.service'
import { SettingsService } from './containers/settings/settings.service'
import { DataCyclesService } from './containers/data-cycles/data-cycles.service'
import { TemplatesService } from './containers/templates/templates.service'
import { SharedService } from './shared/shared.service'
import { PropertiesService } from './containers/properties/properties.service'
import { IndustriesService } from './containers/industries/industries.service'
import { OrganizationsService } from './containers/organizations/organizations.service'
import { ContactTitlesService } from './containers/contact-titles/contact-titles.service'
import { CommunitiesService } from './containers/communities/communities.service'
import { ImageTypesService } from './containers/image-types/image-types.service'
import { StreetTypesService } from './containers/street-types/street-types.service'
import { StreetsService } from './containers/streets/streets.service'
import { UsersService } from './containers/users/users.service'
import { AuthService } from './containers/auth/auth.service'
import { ContactTypesService } from './containers/contact-types/contact-types.service'
import { FormsService } from './containers/forms/forms.service'
import { PropertyTypeTemplatesService } from './containers/property-type-templates/property-type-templates.service'
import { FinancialInstitutionsService } from '@containers/financial-institutions/financial-institutions.service'
import { PaymentPurposesService } from '@containers/payment-purposes/payment-purposes.service'
import { CommercialLicenseMappingsService } from '@containers/commercial-license-mappings/commercial-license-mappings.service'
import { AuditLogsService } from '@containers/audit-logs/audit-logs.service'
import { WardsService } from '@containers/wards/wards.service'
import { BusinessCategoriesService } from '@containers/business-categories/business-categories.service'
import { SystemSettingsService } from '@containers/system-settings/system-settings.service'
import { SecuritySettingsModule } from '@containers/security-settings/security-settings.module'
import { SecuritySettingsService } from '@containers/security-settings/security-settings.service'
import { SmtpSettingsService } from '@containers/smtp-settings/smtp-settings.service'
import { GisSettingsService } from '@containers/gis-settings/gis-settings.service'
import { PathSettingsService } from '@containers/path-settings/path-settings.service'
import { DigitizationService } from '@containers/digitization/digitization.service'
import { UnitsSettingsService } from '@containers/units-settings/units-settings.service'
import { LayerService } from '@containers/layer/layer.service'
import { MobileUsersService } from '@containers/mobile-users/mobile-users.service'
import { MobileSettingsService } from '@containers/mobile-settings/mobile-settings.service'
import { StaticContentTemplatesService } from '@containers/static-content-templates/static-content-templates.service'
import { MobileTasksService } from '@containers/mobile-tasks/mobile-tasks.service'
import { LicenseGenerationSettingsService } from '@containers/license-generation-settings/license-generation-settings.service'
import { UISettingsService } from '@containers/ui-settings/ui-settings.service'
import { CompoundsService } from '@containers/compounds/compounds.service'
import { LicenseTypesService } from '@containers/license-types/license-types.service'
import { NotDeliveredReasonService } from '@containers/not-delivered-reason/not-delivered-reason.service'
import { ExternalDashboardsSettingsService } from '@containers/external-dashboard-settings/external-dashboard-settings.service'
import { FormPostprocessorsService } from '@containers/form-postprocessors/form-postprocessors.service'
import { CompoundSettingsService } from '@containers/compound-settings/compound-settings.service'
import { MapAnalyticsService } from '@containers/map-analytics/map-analytics.service'

const services = [
  AuthService,
  UsersService,
  StreetsService,
  StreetTypesService,
  ContactTypesService,
  ImageTypesService,
  FormsService,
  CommunitiesService,
  ContactTitlesService,
  OrganizationsService,
  IndustriesService,
  PropertiesService,
  TemplatesService,
  DataCyclesService,
  SettingsService,
  PropertyTypeTemplatesService,
  PdfBatchGenerationService,
  DocumentTypesService,
  SharedService,
  BusinessesService,
  RolesService,
  FinancialInstitutionsService,
  PaymentPurposesService,
  CommercialLicenseMappingsService,
  AuditLogsService,
  FixedTemplatesService,
  ReportsService,
  MapService,
  DashboardService,
  WardsService,
  SearchResultsService,
  DiscountGroupsService,
  ProfileService,
  BusinessCategoriesService,
  SystemSettingsService,
  SecuritySettingsModule,
  SecuritySettingsService,
  SmtpSettingsService,
  GisSettingsService,
  PathSettingsService,
  UnitsSettingsService,
  DigitizationService,
  LayerService,
  MobileUsersService,
  MobileSettingsService,
  StaticContentTemplatesService,
  MobileTasksService,
  LicenseGenerationSettingsService,
  UISettingsService,
  CompoundsService,
  LicenseTypesService,
  NotDeliveredReasonService,
  ExternalDashboardsSettingsService,
  FormPostprocessorsService,
  CompoundSettingsService,
  MapAnalyticsService,
]

export { services }
